module.exports = __webpack_public_path__ + "static/media/2.d791408b.svg";